import React, { useState } from 'react'
import FilterRDSPAL from '../components/FilterRDSPAL.jsx'
import WaterLevel from '../components/Chart/WaterLevel.jsx';

const HistoryByTrip = ({ onDataToleransi }) => {

    const [data, setData] = useState([]);

    return (
        <div className="flex flex-col items-center justify-around w-full rounded gap-4 bg-white p-4">
            <div className="flex flex-col gap-4 items-center justify-center">
                {/* <h2 className="text-2xl">HISTORY BY TRIP</h2> */}
                <FilterRDSPAL onData={(values) => setData(values)} onDataToleransi={onDataToleransi} />
            </div>

            <div className="flex flex-col lg:flex-row justify-evenly items-center gap-6 w-full">
                <WaterLevel dataSource={data.BBM_IN} title="Filling" />
                <WaterLevel dataSource={data.BBM_OUT} title="Consumption" />
            </div>
        </div>
    )
}

export default HistoryByTrip